import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from '@material-ui/core/Tooltip';
import HelpIcon from '@material-ui/icons/Help';
import { makeStyles } from '@material-ui/core';

function HelpTooltip(_ref) {
    var help = _ref.help;

    var classes = useStyles();
    return !!help && React.createElement(
        Tooltip,
        { title: help, enterDelay: 500, leaveDelay: 200 },
        React.createElement(HelpIcon, { className: classes.helper })
    );
}

HelpTooltip.propTypes = process.env.NODE_ENV !== "production" ? {
    help: PropTypes.string
} : {};

var useStyles = makeStyles(function (theme) {
    return {
        helper: {
            position: 'absolute',
            top: 0,
            right: 0,
            width: theme.spacing(2),
            height: theme.spacing(2),
            color: theme.palette.action.active,
            '&:hover': {
                color: theme.palette.common.black
            }
        }
    };
});

export default HelpTooltip;